import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import styled from "styled-components";

const tabSequence = [
  "tab0",
  "tab1",
  "tab2",
  "tab3a",
  "tab3b",
  "tab4a",
  "tab4b",
  "tab5a",
  "tab5b"
];

function checkMove(tabToMoveTo, currentActive) {
  const indexTabToMoveTo = tabSequence.indexOf(tabToMoveTo);
  const indexCurrentActive = tabSequence.indexOf(currentActive);
  if (indexTabToMoveTo > indexCurrentActive) {
    return false;
  }
  return true;
}

const CircleLi = styled.li`
  color: #fff;
  cursor: ${props => (props.allowMove ? "pointer" : "normal")};
  span {
    background: ${props => (props.active ? props.bg : "#fff")} !important;
    color: ${props => (props.active ? "#fff" : "#000")} !important;
  }
`;

const Circle = props => {
  /* const moveToTab = () => {
    props.moveToTab(props.tab);
  };
  */

  const { number, active, allowMove, baseColour } = props;

  return (
    <CircleLi
      bg={baseColour}
      allowMove={allowMove}
      active={active}
      onClick={allowMove ? this.moveToTab : undefined}
    >
      <span>{number}</span>
    </CircleLi>
  );
};

/*
<li onClick={allowMove ? this.moveToTab : undefined} className={classNames({ active: active, "add-cursor-pointer": allowMove })}>

				<span>{number}</span>
			</li>
			*/

const TabNavigation = props => {
  return null;
  const { tradesOutsideOfTheUk, moveToTab, domainBaseColour } = props;
  const activeTab = new URLSearchParams(props.location.search).get("activeTab");
  return (
    <ul className="form_navigation">
      <Circle
        baseColour={domainBaseColour}
        allowMove={true}
        moveToTab={moveToTab}
        active={activeTab === "tab1"}
        tab="tab1"
        number={1}
      />
      <Circle
        baseColour={domainBaseColour}
        allowMove={checkMove("tab2", activeTab)}
        moveToTab={moveToTab}
        active={activeTab === "tab2"}
        tab="tab2"
        number={2}
      />
      <Circle
        baseColour={domainBaseColour}
        allowMove={checkMove("tab3a", activeTab) && tradesOutsideOfTheUk}
        moveToTab={moveToTab}
        active={activeTab === "tab3a" || activeTab === "tab3b"}
        tab="tab3a"
        number={3}
      />
      <Circle
        baseColour={domainBaseColour}
        allowMove={checkMove("tab4a", activeTab)}
        moveToTab={moveToTab}
        active={activeTab === "tab4a" || activeTab === "tab4b"}
        tab="tab4a"
        number={4}
      />
      <Circle
        baseColour={domainBaseColour}
        allowMove={checkMove("tab5a", activeTab)}
        moveToTab={moveToTab}
        active={activeTab === "tab5a" || activeTab === "tab5b"}
        tab="tab5a"
        number={5}
      />
    </ul>
  );
};

const mapStateToProps = state => {
  return {
    ...state.app
  };
};
const mapDispatchToProps = dispatch => {
  return {};
};
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TabNavigation)
);
